import FileUploadContainer from './containers/FileUploadContainer';

export default FileUploadContainer;
